<app-programtitle title="VAT (Value Added Tax) calculator"></app-programtitle>

<p> Write a program to calculate VAT. Use VAT 20%.</p>

<p> As an exercise, you can ask the user to input the VAT percentage and use it in your calculations.</p>

<app-editor code="{{program}}"> </app-editor>

